import { NotifyHelper } from "../../../helpers/toast";
import { eMucThuTinChiActionsObj } from "../../action-types/muc-thu/IMucThuTinChiActionTypes";

import { generateActionForKey, generateActions } from "../generateActions";

export const mucThuTinChiActions = {
  ...generateActions(eMucThuTinChiActionsObj, "MUC_THU_TIN_CHI"),
};
